module.exports = __webpack_public_path__ + "static/img/solu6.281b199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Solution/img/solu6.jpg
// module id = R3/F
// module chunks = 1